import { lazy } from 'react';

export const lazyPages = {
  ListiclePage: lazy(() => import('../pages/ListiclePage')),
  DirectoryPage: lazy(() => import('../pages/DirectoryPage')),
  AboutPage: lazy(() => import('../pages/AboutPage')),
  NotFoundPage: lazy(() => import('../pages/NotFoundPage')),
  PrivacyPolicy: lazy(() => import('../pages/legal/PrivacyPolicy')),
  TermsOfService: lazy(() => import('../pages/legal/TermsOfService')),
  Disclaimer: lazy(() => import('../pages/legal/Disclaimer')),
  AdminLayout: lazy(() => import('../pages/admin/AdminLayout')),
  AdminDashboard: lazy(() => import('../pages/admin/AdminDashboard')),
  AdminEditor: lazy(() => import('../pages/admin/AdminEditor')),
  AdminBulkUpload: lazy(() => import('../pages/admin/AdminBulkUpload'))
};